import React from "react";
import { URL_CONSTANTS } from "../utils/constants";

import '../css/account-expired.css';

const AccountExpiredComponent = () => {
  return (
    <div class="form-hero-section bg-lblack section-padding account-expired">
      <div class="form-container">
        <div class="form-hero-block">
          <div class="form-hero-content">
            <h2>
              Your 15-Day Free Trial Has Ended
            </h2>
            <div>
              <p>We hope you loved your time with Apty’s Content Creation Studio!</p>
            </div>
            <div class="site-text">
              <p>Ready to take the next step? Get in touch with us to continue your journey toward seamless product adoption</p>
            </div>
          </div>
          <div class="form-hero-code">
            <div class="step-form-block">
              <div class="form-response">
                <div class="form-response-image">
                  <img src="https://www.apty.io/wp-content/uploads/2025/01/expired.svg" style={{maxWidth: '100%'}} alt=""/>
                    <div class="form-response-text">
                      <div class="fs-24 fw-500">Uh-oh! </div>
                      <div class="color-text">Your 15-Day Free Trial Has Ended</div>
                    </div>
                </div>
                <div class="form-footer mt-20 text-center">
                  <a href={URL_CONSTANTS.BOOK_A_DEMO} target="_blank" rel="noopener" class="form-btn">Book a Demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountExpiredComponent;
